<template>

    <b-modal id="modal-trocar-email" dialog-class="modal-conta" size="md" hide-footer :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 class="modal-title">Trocar e-mail</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-trocar-email')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
      <h2 v-if="empresasB2bDoEstudante.length > 0"> Esse email possui acesso na(s) empresa(s) b2b: <strong>{{empresasB2bDoEstudante.join(', ')}}</strong>. Ainda assim, deseja trocar o email desse usuário?</h2>

      <form>
        <b-form-group
          id="input-group-1"
          label="Insira o novo e-mail"
          label-for="novo-email"
        >
          <b-form-input
            id="novo-email"
            type="email"
            required
            placeholder="aluno@email.com"
            v-model="novoEmail"
          ></b-form-input>
        </b-form-group>
        <div class="text-center">
          <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
            <button class="btn btn-primary mr-3" type="button" @click="trocarEmail(estudanteId)">Trocar e-mail</button>
            <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-trocar-email')">Cancelar</a>
          </div>
        </div>
      </form>
    </b-modal>

</template>

<script>
import UsuarioAPI from '@/api/usuario-api'
import Swal from 'sweetalert2'
import ResponseUtils from '@/core/util/response-utils'

export default {
  name: 'TrocaEmail',
  props: {
    estudanteId: Number
  },
  data () {
    return {
      novoEmail: null,
      empresasB2bDoEstudante: []
    }
  },

  async mounted () {
    this.$root.$on('bv::modal::show', async (bvEvent, modalId) => {
      if (modalId === 'modal-trocar-email') {
        let usuarioInfo = await UsuarioAPI.obterPorId(this.estudanteId)
        let empresasB2bDoEstudante = []
        usuarioInfo.empresas.map(item => {
          if (item.b2b) {
            empresasB2bDoEstudante.push(item.empresa)
          }
        })
        this.empresasB2bDoEstudante = empresasB2bDoEstudante
      }
    })
  },

  methods: {
    trocarEmail: function (estudanteId) {
      let estudanteEmail = this.novoEmail

      UsuarioAPI.trocarEmail({ userId: estudanteId, email: estudanteEmail }).then(data => {
        Swal.fire({
          icon: 'success',
          showCloseButton: true,
          text: 'E-mail do aluno trocado com sucesso!'
        }).then(() => {
          this.novoEmail = null
          this.$parent.limparFiltro()
          this.$bvModal.hide('modal-trocar-email')
        })
      }).catch(error => ResponseUtils.handleError(error))
    }
  }
}
</script>
